export const iconFontAwesomeDevicesHardwareUpload = (
	<i className="fa-solid fa-upload"></i>
);
